// extracted by mini-css-extract-plugin
export default {"fs":"_065b6f3bdd _198c75990a"};